var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBagicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.613284 11.5761C0.613284 14.9735 3.69066 16.4999 7.99904 16.4999C12.3074 16.4999 15.3848 14.9735 15.3848 11.6007C15.3848 8.372 13.9733 6.53582 11.1505 4.87477C9.28818 6.27926 6.70218 6.27773 4.84142 4.87018C2.02266 6.51387 0.613284 8.34973 0.613284 11.5761ZM6.00684 3.93779L4.55534 1.66955C4.4926 1.54912 4.46151 1.41472 4.46517 1.27899C4.46871 1.14325 4.50677 1.01066 4.5757 0.893695C4.64465 0.776727 4.74222 0.679229 4.85925 0.61038C4.97628 0.541531 5.1089 0.503595 5.24463 0.500145H10.4639C10.6087 0.497393 10.7515 0.533985 10.8771 0.60602C11.0027 0.678055 11.1064 0.782832 11.1772 0.909179C11.2479 1.03553 11.2831 1.17871 11.2789 1.32345C11.2746 1.4682 11.2312 1.60909 11.1532 1.7311L9.95658 3.95874C8.74363 4.68523 7.2137 4.67825 6.00684 3.93779Z",
    fill: "#9EA3AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagicon);
export default __webpack_public_path__ + "static/media/bagicon.b132abf853b2f997c744ac0b93b3fd7f.svg";
export { ForwardRef as ReactComponent };